<i18n>
{
  "en": {
    "agent": {
      "title": "Agent",
      "title0": "Agents",
      "tabs": {
        "agent": "Agent",
        "networks": "Networks",
        "settings": "Settings",
        "logs": "Logs"
      },
      "newAgent": "New agent"
    }
  },
  "ru": {
    "agent": {
      "title": "Агент",
      "title0": "Агенты",
      "tabs": {
        "agent": "Агент",
        "networks": "Сети",
        "settings": "Настройки",
        "logs": "Журнал"
      },
      "newAgent": "Новый агент"
    }
  }
}
</i18n>

<template>
  <div>
    <div class="content-block dx-card responsive-paddings">
      <dx-tab-panel
        :data-source="tabViews"
        :selected-index="selectedIndex"
        :loop="false"
        :animation-enabled="false"
        @selection-changed="onSelectionChanged"
      >
        <template #title="view">
          <span>{{ view.data.title }}</span>
        </template>

        <template #item="view">
          <div class="tabpanel-item">
            <component v-bind:is="view.data.id" :id="id" :agent="agent" :locationsItems="locations" />
          </div>
        </template>
      </dx-tab-panel>
    </div>
  </div>
</template>

<script>
import baseView from "../base.vue";
import appInfo from "../../app-info";

import DxTabPanel from "devextreme-vue/tab-panel";

import AgentDetail from "./detail";
import AgentNetworks from "./networks";
import AgentLogs from "./logs";
import { formatAgentStatusText } from './constants';

import { getAgent, getUserLocations } from '@/services/api';
import { DataLocation } from "@/mixins/dataLocationMixin";

function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );
}

export default {
  props: ["id"],
  extends: baseView,
  mixins: [DataLocation],
  components: {
    DxTabPanel, AgentDetail, AgentNetworks, AgentLogs,
  },
  data() {
    return {
      agent: null,
      locations: [],
      user: this.$store.getters.user,
      isCloudMode: this.$store.getters.isCloudMode
    };
  },
  computed: {
    agentId() {
      return Number(this.$route.params.id);
    },
    isNew() {
      return this.agentId < 0;
    },
    tabViews() {
      const tabs = [{
        id: "agent-detail",
        title: this.$t("agent.tabs.agent"),
      }, {
        id: "agent-networks",
        title: this.$t("agent.tabs.networks"),
        disabled: this.isNew
      }, {
        id: "agent-logs",
        title: this.$t("agent.tabs.logs"),
        disabled: this.isNew
      }];

      return tabs;
    },
    selectedIndex() {
      const tab = this.$route.query.tab;

      switch (tab) {
        case "agent-networks":
          return 1;
        case "agent-logs":
          return 2;
        default:
          return 0;
      }
    }
  },
  methods: {
    onSelectionChanged(e) {
      if (!e.addedItems || !e.addedItems.length) return;

      const tab = e.addedItems[0].id;
      const currentTab = this.$route.query.tab || null;
      let nextTab = null;

      switch (tab) {
        case "agent-detail":
          nextTab = null;
          break;
        default:
          nextTab = tab;
      }

      if (currentTab === nextTab)
        return;

      const query = { ...this.$route.query };
      if (nextTab) {
        query.tab = nextTab;
      } else {
        delete query.tab;
      }

      this.$router.replace({ query }).catch(() => {});
    },
    updateBreadcrumb() {
      let breadcrumb = [{
        link: '/agents',
        title: this.$t('agent.title0')
      }];

      if (!this.isNew) {
        let fullPathLocation = this.getFullPath(this.agent.location.id);
        fullPathLocation = fullPathLocation.map((location) => {
          return {
            link: `/location/${location.id}`,
            title: location.name
          };
        });

        breadcrumb = breadcrumb.concat(fullPathLocation).concat({
          link: `/agent/${this.agentId}`,
          title: this.agent.url
        });
      } else {
        breadcrumb = breadcrumb.concat({
          link: '',
          title: this.$t('agent.newAgent')
        })
      }

      this.$store.commit('setBreadcrumb', breadcrumb);
    },
    async loadAgent() {
      try {
        this.locations = await getUserLocations();

        if (!this.isNew) {
          this.agent = await getAgent(this.agentId);
          this.agent.statusText = formatAgentStatusText(this.agent.status);
        } else {
          const defaultLocation = this.locations.find(location => location.code === 'DEFAULT');
          const location = defaultLocation ? defaultLocation : null;

          this.agent = { location };
          this.agent.securityToken = uuidv4();
        }

        this.updateBreadcrumb();
      } catch(err) {
        this.onDataError(err);
      }
    },
  },
  created() {
    document.title = `${appInfo.title} - ${this.$t('agent.title')}`;

    this.loadAgent();
  },
  watch: {
    id() {
      this.loadAgent();
    }
  }
};
</script>

<style lang="scss">
</style>
